import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueMoment from 'vue-moment'
import VueMeta from 'vue-meta'
import i18n from './i18n'
import moment from 'moment-timezone'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

moment.tz.setDefault('Europe/Amsterdam');

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueMoment)
Vue.component('v-select', vSelect)


Vue.filter('currency', function(value){
  return '€ ' + parseFloat(value).toLocaleString('nl-NL', {minimumFractionDigits: 2})
})

Vue.filter('time_format', function(value){
  return moment(value).format('HH:mm')
})

Vue.filter('date_time', function(value){
  return moment(value).format('DD-MM-YYYY HH:mm')
})

Vue.filter('date_written', function(value){
  return moment(value).format('ddd D MMMM YYYY')
})

Vue.filter('date_full', function(value){
  return moment(value).format('dddd D MMMM YYYY HH:mm')
})

Vue.use(VueMeta)

new Vue({
  render: h => h(App),
  router,
  i18n,
  store
}).$mount('#app')
